<pt-main-screen
    *ngIf="isConnected"
    [inSession]="isConnected"
    [controlsEnabled]="isMaster && (showControls|async)"></pt-main-screen>
